export default "__VITE_ASSET__BMPiCO2j__"